import './ChatAIDaySeparator.scss';

interface ChatAIDaySeparatorProps {
    label: string;
}

/** Смена календарного дня в ленте: «Сегодня», «Вчера», «5 марта». */
export function ChatAIDaySeparator({ label }: ChatAIDaySeparatorProps) {
    return <div className="chat-ai-day-separator">{label}</div>;
}
